import React from "react";
import { createTheme, ButtonGroup, Button, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ActiveButton } from "../../../Redux/Action";
import { EODINTERVALS } from "./config";
import "./GrpBtn.css";

const labelMap = {
  OneMinute: "1m",
  FiveMinute: "5m",
  FifteenMinute: "15m",
  ThirtyMinute: "30m",
  OneHour: "1hr",
  Daily: "day",
  Weekly: "wk",
  Monthly: "mon",
};

function GroupButtons() {
  const isLoading = useSelector((state) => state.isLoading);
  const selectedAnalytics = useSelector((state) => state.selectedAnalytics);
  const Indicators = useSelector((state) => state.SelectedDropdownOption);
  const setActiveButton = useSelector((state) => state.ActiveButton);
  const dispatch = useDispatch();

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  });
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const handleClick = (index) => {
    dispatch(ActiveButton(index));
  };

  const buttonConfig = EODINTERVALS[Indicators] || EODINTERVALS["Default"];

  const buttonStyles = (buttonName) => ({
    bgcolor: setActiveButton === buttonName ? "#ccdcff" : "#e6eeff",
    textTransform: "none",
    color: "black",
    "&:disabled": {
      backgroundColor: "#e6eeff",
      color: "darkgrey",
    },
  });

  const isDisabled = (buttonName) => {
    const commonDisabled =
      // Indicators === "RSLEVEL_CLASSIC" ||
      Indicators === "Mean_Reversion" ||
      Indicators === "Returns" ||
      Indicators === "Volume_Analysis" ||
      Indicators === "Key_Metrics" ||
      isLoading;
    if (
      buttonName === "Daily" ||
      buttonName === "Weekly" ||
      buttonName === "Monthly"
    ) {
      return (
        commonDisabled ||
        Indicators === "Returns" ||
        Indicators === "Volume_Analysis"
      );
    }
    return commonDisabled;
  };

  return (
    <ButtonGroup
      variant="outlined"
      aria-label="Basic button group"
      size="small"
      sx={{
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      }}
    >
      {buttonConfig.map((buttonKey) => (
        <Button
          key={buttonKey}
          onClick={() => handleClick(buttonKey)}
          sx={buttonStyles(buttonKey)}
          disabled={isDisabled(buttonKey)}
        >
          {labelMap[buttonKey] || buttonKey.toLowerCase()}
        </Button>
      ))}
    </ButtonGroup>
  );
}

export default GroupButtons;
